import React from 'react'; // eslint-disable-line no-unused-vars
import config from '~/components/config';

export const Anchor = (props) => {
    if (config.useCustomAnchors) {
        return <config.Anchor {...props} />;
    }
    return (<a {...props} />);
};
